import { KText } from '@/ui-library/components';
import { Flex, Center } from '@chakra-ui/react';
import dayjs from 'dayjs';
import { useField } from 'formik';
import { useDateFormat } from '@/hooks/useDateFormat';
import { DatePopOver } from './DatePopOver';

interface QuickItem {
  id: string;
  label: string;
  date: string;
}

export const PauseForCustomField = () => {
  const [, meta, helpers] = useField('pauseUntill');
  const [, customMeta, customHelpers] = useField('customDate');
  const { setValue } = helpers;
  const { setValue: setCustom } = customHelpers;
  const { dateFormat } = useDateFormat();
  const dateFmt = dateFormat?.label || 'DD/MM/YYYY';
  const currDate = dayjs();

  const items: QuickItem[] = [
    {
      id: 'week',
      label: '1 week',
      date: currDate.add(7, 'day').format(dateFmt),
    },
    {
      id: 'month',
      label: '1 month',
      date: currDate.add(1, 'month').format(dateFmt),
    },
    {
      id: '3month',
      label: '3 months',
      date: currDate.add(3, 'month').format(dateFmt),
    },
  ];

  const onQuickClick = (item: QuickItem) => {
    setValue(item.id);
    setCustom('');
  };

  const onCustomDateClick = (
    date: Date | undefined,
    onClose: () => void = () => {}
  ) => {
    setValue('custom');
    setCustom(date);
    onClose();
  };

  return (
    <Flex flexDir="column" gap="6px">
      <KText size="sm-semi-bold" color="secondary-900">
        Pause for
      </KText>
      <Flex
        border="1px solid"
        borderColor="border-color"
        borderRadius="sm"
        w="100%"
        minH="50px"
        overflow="hidden"
      >
        {items?.map((item) => (
          <Center
            key={item?.id}
            w="25%"
            flexDir="column"
            borderRight="1px solid"
            borderColor="border-color"
            bg={meta?.value === item?.id ? 'ats-primary' : undefined}
            cursor="pointer"
            onClick={() => onQuickClick(item)}
          >
            <KText
              size="sm-medium"
              color={meta?.value === item?.id ? 'base-white' : 'secondary-900'}
            >
              {item?.label}
            </KText>
            <KText
              size="sm-medium"
              color={meta?.value === item?.id ? 'base-white' : 'secondary-700'}
            >
              {item?.date}
            </KText>
          </Center>
        ))}
        <DatePopOver
          meta={meta}
          date={customMeta?.value}
          setDate={onCustomDateClick}
          dateFormat={dateFmt}
        />
      </Flex>
    </Flex>
  );
};
